import React, { useEffect, useState } from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import AiPower from "../../assets/images/AiPower.svg";
import Education from "../../assets/images/Education.svg";
import Mentor from "../../assets/images/Mentor.svg";
import Enterprise from "../../assets/images/Enterprise.svg";
import AiPowerIcon from "../../assets/icon/AiPower";
import EducationIcon from "../../assets/icon/Education";
import MentorIcon from "../../assets/icon/UserIcon";
import EnterpriseIcon from "../../assets/icon/Enterprise";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

const fetureData = [
  {
    img: AiPower,
    icons: <AiPowerIcon />,
    title: "AI-Powered SOPs",
    content:
      "Intelligent standard operating procedures that adapt to your business needs ",
  },
  {
    img: Education,
    icons: <EducationIcon />,
    title: "Educational Platform",
    content:
      "Personalized learning paths with AI-driven curriculum optimization",
  },
  {
    img: Mentor,
    icons: <MentorIcon />,
    title: "Mentor Assistance",
    content: "24/7 AI-powered professional development and guidance",
  },
  {
    img: Enterprise,
    icons: <EnterpriseIcon />,
    title: "Enterprise AI",
    content: "Seamless integration of AI capabilities across your organization",
  },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const [isLoggedin, setIsLoggedin] = useState(false);

  useEffect(() => {
    const isAuth = user && Object.keys(user).length > 0;
    const token = localStorage.getItem("GuideproAI_user");
    const isTokenValid = !!token;
    setIsLoggedin(isAuth || isTokenValid);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="h-[calc(100vh-100px)] bg-hero flex items-center py-10">
        <div className="container">
          <div className="mb-10">
            <h1
              className="hero-title wow animate__animated animate__fadeInDown"
              // data-wow-delay="0.3s"
            >
              Revolutionizing Through{" "}
              <span className="text-title">Artificial Intelligence</span>
            </h1>
          </div>
          <div className="mb-10 lg:mb-20">
            <h3 className="!text-white wow animate__animated animate__fadeInDown">
              Transforming warehouse operations, education, and mentorship with
              cutting-edge AI solution. Streamline your processes, enhance
              learning, and get expert guidance.{" "}
            </h3>
          </div>
          <div
            className="flex items-center gap-4 max-tab:flex-col wow animate__animated animate__fadeInUp"
            data-wow-delay="0.3s"
          >
            <button
              onClick={() => {
                if (isLoggedin) {
                  navigate("/home");
                } else {
                  navigate("/login");
                }
              }}
              className="btn-large btn-primary"
            >
              {isLoggedin ? "Go To Home" : "Get Started"}
            </button>
            <button
              onClick={() => {
                if (isLoggedin) {
                  navigate("/home");
                } else {
                  navigate("/login");
                }
              }}
              className="btn-large btn-more text-white hover:opacity-80 duration-200"
            >
              Learn More{" "}
              <div>
                <HiArrowNarrowRight className="text-white text-2xl" />
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Transforming Feature */}
      <div className="py-12 lg:py-100">
        <div className="container">
          <div
            className="text-center grid gap-4 max-w-[721px] mx-auto pb-6 lg:pb-50 wow animate__animated animate__fadeIn"
            data-wow-delay="0.3s"
          >
            <h3 className="title">Transforming Feature</h3>
            <h6>
              Our AI-powered solutions deliver intelligent automation, advanced
              learning systems, and personalized mentorship across your
              organization.
            </h6>
          </div>
          <div className="grid lg:grid-cols-2 gap-30">
            {fetureData.map((item, index) => (
              <div
                key={index}
                className="border border-border_sec rounded-10 overflow-hidden wow animate__animated animate__fadeInUp"
              >
                <div className="relative max-h-[220px] overflow-hidden">
                  <img
                    src={item.img}
                    alt=""
                    className="max-h-[220px] h-full w-full object-cover bg-cover bg-center"
                  />
                  <div className="relative shadhow-blurs"></div>
                  <div className="absolute left-5 bottom-5 z-20">
                    {item.icons}
                  </div>
                </div>
                <div className="p-4 tab:p-6 grid gap-3">
                  <h4 className="font-semibold">{item.title}</h4>
                  <p className="text-gray">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
